(function ($) {

	// Update cart
	function update_methods() {

		let url = ghostpress_params.ajax_url + "&action=cart_update_methods",
			data = $(this).serializeArray()

		gp_ajax({
			url: url,
			type: "post",
			dataType: "json",
			data: data,
			show_loading: true
		})
	}

	// Zasilkovna pickup point

	function open_zasilkovna_pickup_widget() {
		// Open widget
		Packeta.Widget.pick(
			zasilkovna_widget_params.zasilkovna_api_key,
			zasilkovna_widget_callback,
			{
				"country": $("select[name='shipping_country']").val().toLowerCase(),
				"language": zasilkovna_widget_params.language
			}
		)
	}

	function zasilkovna_widget_callback(locationData) {

		if (locationData != null && typeof locationData !== "undefined") {

			$("input[name='shipping_pickup_point_id']").val(locationData.id);
			$("input[name='shipping_company_name']").val(locationData.place);
			$("input[name='shipping_address_line_1']").val(locationData.street);
			$("input[name='shipping_city']").val(locationData.city);
			$("input[name='shipping_zip']").val(locationData.zip);

			$("form#checkout-methods-form").trigger("change")
			return true;
		}

		return false;
	}

	function balikovna_event_listener(event) {
		if (event.data.message === 'pickerResult') {
			let point = event.data.point;

			$("input[name='shipping_pickup_point_id']").val(point.zip); // point.id has an extra B at start
			$("input[name='shipping_company_name']").val(point.name);
			$("input[name='shipping_address_line_1']").val(point.street);
			// provided zip isn't zip but pickup point id
			let parsed = point.address.match(/.*, ([0-9]{5}), (.*)/); // Vladivostocká 1460/10, Vršovice, 10000, Praha 10
			let zip = parsed[1];
			let city = parsed[2];
			if(!city){
				city = point.municipality_name;
			}
			if(!zip){
				zip = point.zip;
			}
			$("input[name='shipping_city']").val(city);
			$("input[name='shipping_zip']").val(zip); // for shipping label is required point.zip not zip from address

			close_balikovna_widget();

			$("form#checkout-methods-form").trigger("change");
		}
	}

	function close_balikovna_widget() {
		$('#balikovna_dialog').removeClass('--open');
	}

	function open_balikovna_pickup_widget() {
		let $dialog = $('#balikovna_dialog');
		if(!$dialog.length){
			$dialog = $('<div id="balikovna_dialog" class="modal-pickup-point"></div>');
			let $button = $('<button type="button" class="modal-pickup-point__close">✕</button>');
			let $iframe = $('<iframe ' +
				'class="modal-pickup-point__iframe" ' +
				'title="Výběr místa pro vyzvednutí zásilky" ' +
				'src="'+ghostpress_params.balikovna_iframe+'" ' +
				'allow="geolocation" />');
			$dialog.append($iframe);
			$dialog.append($button);
			$dialog.on('click', function (e){
				if(e.target === this){
					close_balikovna_widget();
				}
			})
			$button.on('click', close_balikovna_widget)
			$('body').append($dialog);
			window.addEventListener('message', balikovna_event_listener);
		}

		$dialog.addClass('--open');
	}

	function maybe_hide_apple_pay() {

		if (!window.ApplePaySession || !ApplePaySession.canMakePayments()) {
			let $apple_pay_input = $('input[name="payment_method_id"][value*="apple_pay"]')
			if ($apple_pay_input.is(':checked')) {
				$apple_pay_input.prop('checked', false)
			}

			$apple_pay_input.closest('.checkout-method-radio').hide()
		}
	}

	$(document).gp_ready(function () {

		// Init again fields from AJAX fragments
		$("form#checkout-methods-form").off("change").change(update_methods)

		// Pickup points
		$("[data-select-pickup-point]").off("click").click(function () {
			let method_type = $(this).data("select-pickup-point")
			switch (method_type) {
				case 'zasilkovna_pick_up_point':
					open_zasilkovna_pickup_widget()
					break;
				case 'balikovna_pick_up_point':
					open_balikovna_pickup_widget()
					break;
			}
		})

		maybe_hide_apple_pay()
	})

})(jQuery);